<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.complaintID')}} #{{complaint.complaintId}}
                    </label>
                </div>
                <div class="row md-5 pt-2">
                    <v-btn v-if="userRole == 16"
                           @click="convertEdit()"
                           color="btn-primary"
                           v-on="on">
                        <div>{{editText}}</div>
                    </v-btn>
                    <div v-if="userRole == 16" class="col-auto">
                        <v-menu v-if="hasMenuOptions" offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn color="btn-primary"
                                       v-on="on">
                                    <div>{{$t('shared.actionHere')}}</div>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile v-if="complaint.complaintStatus == 2 && complaint.senderStatus == 4 && userRole == 16"
                                             @click="showReactivateDialog()">
                                    <v-list-tile-title class="white">{{$t('senderComplaints.reactivate')}}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="complaint.complaintStatus == 1 &&  userRole == 16 &&(complaint.senderStatus == 7 ||complaint.senderStatus == 5)"
                                             @click="showCloseComplaintDialog()">
                                    <v-list-tile-title class="white">{{$t('senderComplaints.closeComplaint')}}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="complaint.complaintStatus == 1 &&  userRole == 16 &&(complaint.senderStatus == 7 ||complaint.senderStatus == 5)"
                                             @click="showDeactivateComplaintDialog()">
                                    <v-list-tile-title class="white">{{$t('senderComplaints.deactivate')}}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row pb-3">
                        <div v-if="complaint.senderStatus == 6 && userRole == 16" class="col-md-9">
                            <v-icon x-large style="color:red">warning_amber</v-icon><span style="color: red; top: -10px; position: relative;">{{$t('senderComplaints.noActionCanBeTakenOnThisBecauseTheSenderNameIsDeleted')}} </span>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-md-9">
                            <div class="row">

                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.providerName')}}</label>
                                    <h4 class="user_info_txt">{{complaint.providerName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                                    <h4 class="user_info_txt">{{getCustomerTypeText(complaint.customerType)}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0" v-if="complaint.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="complaint.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="complaint.customerType === 3">{{$t('shared.commercialRegistrationNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="complaint.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                    <h4 class="user_info_txt no-collapse">{{complaint.referenceNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.senderName')}}</label>
                                    <h4 class="user_info_txt">{{complaint.senderName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                                    <h4 class="user_info_txt">
                                        <span v-for="(type, index) in senderType" :key="type">
                                            {{getSenderTypeText(type)}}
                                        </span>
                                    </h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                                    <h4 class="user_info_txt">{{complaint.clientName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                                    <h4 class="user_info_txt">{{complaint.representativeName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.apEmail')}}</label>
                                    <h4 class="user_info_txt">{{complaint.representativeEmail}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.phoneNumber')}}</label>
                                    <h4 v-if="complaint.customerType === 1 ||complaint.customerType === 2 ||complaint.customerType === 3" class="user_info_txt"><span class="pr-3">+966</span> {{complaint.representativePhone}}</h4>
                                    <h4 v-if="complaint.customerType === 4" class="user_info_txt">{{complaint.representativePhone}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderCriticality')}}</label>
                                    <h4 v-if="complaint.isCritical" class="user_info_txt">{{$t('shared.critical')}}</h4>
                                    <h4 v-if="!complaint.isCritical" class="user_info_txt">{{$t('shared.notCritical')}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderExpiryDate')}}</label>
                                    <h4 class="user_info_txt">{{complaint.senderExpiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.gracePeriod')}}</label>
                                    <h4 class="user_info_txt">{{complaint.gracePeriod}}</h4>
                                </div>
                                <div v-if="userRole == 16" class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.deactivatedby')}}</label>
                                    <h4 class="user_info_txt">{{complaint.deactivatedBy}}</h4>
                                </div>
                                <div v-if="userRole == 16" class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.reactivatedBy')}}</label>
                                    <h4 class="user_info_txt">{{complaint.reactivatedBy}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <Progress :transitionDuration="1000" :radius="120" :strokeColor="checkColor(complaint.senderStatus)" :strokeWidth="10" :value="getRate()">
                                <div class="content">
                                    <input class="w-100" :class="'status-' + complaint.senderStatus">{{GetSenderStatus(complaint.senderStatus)}}</input>
                                    <p>
                                        {{complaint.gracePeriod}} {{$t('dashboardPage.of')}} {{30}} <br /> {{$t('dashboardPage.daysLeft')}}
                                    </p>
                                </div>
                            </Progress>
                        </div>
                    </div>
                    <div class="row col-md-9">
                        <label class="user_info_header mb-3">{{$t('shared.comment')}}</label>
                        <input class="form-control" :disabled="!isEditMode" type="text" v-model="complaint.comments" />
                    </div>
                    <div v-if="isEditMode" class="row col-md-4">
                        <div class="form-group">
                            <label>{{$t('shared.attachmentList')}}</label>
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left" readonly
                                       type="text" />
                                <input type="file" ref="contractAttachment" hidden accept=".pdf, .docx"
                                       @change="onFilePicked" />
                                <div class="input-group-prepend">
                                    <span class="input-group-text right" style="padding: 2px 2px 0px 2px !important;">
                                        <button :disabled="!canAddAttachment" class="btn btn-primary" @click="onPickFile()">
                                            {{$t('shared.add')}}
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 10px;">
                        <div class="col-md-12 pr-0">
                            <div class="card card_layout">
                                <div class="card-body">
                                    <template>
                                        <v-data-table :headers="headers" :items="complaint.attachmentList"
                                                      class="elevation-1 table-striped"
                                                      hide-actions>
                                            <template v-slot:items="props">
                                                <tr>
                                                    <td class="text-center">
                                                        {{ props.item.fileName }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ props.item.createdDate }}
                                                    </td>
                                                    <td v-if="userRole == 16" class="text-center">
                                                        {{ props.item.createdBy }}
                                                    </td>
                                                    <td class="text-center">
                                                        <i class="fas fa-file-download Icon_Edit"
                                                           @click="downloadFile(props.item)"></i>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/SenderComplaints" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                                <div v-if="isEditMode" class="col-auto">
                                    <button class="btn btn-success px-5 py-2" @click="showEditComplaintDialog">{{$t('shared.save')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="editComplaintDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.editInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideEditComplaintDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.editComplaintInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideEditComplaintDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="save">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="reactivateDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.reactivateInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideReactivateDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.reactivateInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideReactivateDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="Reactivate">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="closeComplaintDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('senderComplaints.closeComplaint')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideCloseComplaintDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('senderComplaints.closeComplaintInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideCloseComplaintDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="closeComplaint()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deactivateComplaintDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('senderComplaints.deactivateComplaint')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeactivateComplaintDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('senderComplaints.deactivateComplaintInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeactivateComplaintDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deactivateComplaint()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>